/* eslint-disable arrow-body-style */
import http from '@/utils/http';
// import { BenchmarkGameResponse, GameSegmentType } from '@intelligence/pages/PCConsoleBenchmark/types';

// 获取菜单列表
export const getLeftMenuList: () => Promise<any> = () => {
  return http({
    url: '/api/v2/dashboard/benchmark/menu_list',
    method: 'post',
  }) as Promise<any>;
};

// 获取指标注释
export const getExplainInfo: () => Promise<any> = () => {
  return http({
    url: '/api/v2/dashboard/benchmark/rainbow',
    method: 'post',
  }) as Promise<any>;
};

// 获取指标配置
export const getMetricInfo: () => Promise<any> = () => {
  return http({
    url: '/api/v2/dashboard/benchmark/metric_info',
    method: 'post'
  }) as Promise<any>;
};

// 获取配置信息
export const getPageConfig: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/benchmark/get_page_config',
    method: 'post',
    data
  });
};

// 搜索建议
export const getMetricSearch = (payload: { page?: number; page_size?: number; keyword: string; frame_type: string; }): Promise<any> => http({
  url: '/api/v2/dashboard/benchmark/metric/search',
  method: 'get',
  params: payload,
  rawData: true,
  errorHandler: true,
});

// 搜索列表
export const getMetricList = (payload: { page?: number; page_size?: number; keyword: string; frame_type: string; category?: string; metric?: string; genres?: string[]; is_recommend: boolean; }): Promise<any> => http({
  url: '/api/v2/dashboard/benchmark/metric/list',
  method: 'post',
  data: payload,
  errorHandler: true,
});

// 推荐问题列表
export const getQuestionList = (payload: { page?: number; page_size?: number; frame_type: string; }): Promise<any> => http({
  url: '/api/v2/dashboard/benchmark/question/list',
  method: 'get',
  params: payload,
  rawData: true,
  errorHandler: true,
});

// 推荐品类列表
export const getRecommendGenreList = (payload: { page?: number; page_size?: number; frame_type: string; }): Promise<any> => http({
  url: '/api/v2/dashboard/benchmark/genre/recommend_list',
  method: 'get',
  params: payload,
  rawData: true,
  errorHandler: true,
});

// Explore页筛选器列表
export const getExploreSelector = (payload: { frame_type: string; selector_list: Array<string>; }): Promise<any> => http({
  url: '/api/v2/dashboard/benchmark/home/selector',
  method: 'post',
  data: payload,
  errorHandler: true,
});

// Genre列表
export const getGenreList = (payload: { frame_type: string; }): Promise<any> => http({
  url: '/api/v2/dashboard/benchmark/genre/list',
  method: 'get',
  params: payload,
  rawData: true,
  errorHandler: true,
});

// Category列表
export const getCategoryList = (payload: { frame_type: string; }): Promise<any> => http({
  url: '/api/v2/dashboard/benchmark/category/list',
  method: 'get',
  params: payload,
  rawData: true,
  errorHandler: true,
});

// 获取筛选器相关信息
export const getSelectorConfig: (data: any) => Promise<any> = (data) => {
  const { api, ...otherData } = data || {};
  return http({
    url: api || '/api/v2/dashboard/benchmark/selector',
    method: 'post',
    data: otherData || {}
  });
};

// 获取游戏列表
export function getGameList(params: any): Promise<any> {
  return http(`/api/v2/dashboard/benchmark/game_list/search`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

// 获取推荐品类对应的游戏
export function getGenreGameList(params: any): Promise<any> {
  return http(`/api/v2/dashboard/benchmark/custom_genre/game_metric`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

// 添加自定义游戏
// export function addCustomGame(params: {
//   frame_type: string;
//   game_ids: string[];
// }) {
//   return http({
//     url: `/api/v2/dashboard/benchmark/add_custom_game`,
//     method: 'post',
//     data: params,
//   });
// }

// 获取benchamark筛选器配置信息
export const getBenchmarkFilterSetting: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/benchmark/selector',
    method: 'post',
    data
  });
};

// 浏览量API
export const pageViewLog: (data: any, opt?: any) => Promise<any> = (data, opt = {}) => {
  opt = Object.assign(opt, {
    url: `/api/v2/dashboard/benchmark/operationLog`,
    method: 'post',
    data,
    errorHandler: true,
  });
  return http(opt);
};

// 获取指标比例

export const getGamePercentage: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/benchmark/game_percentage',
    method: 'post',
    data
  });
};

// 用户点击了New标记的菜单, 上报已读接口
export const addViewDashboard: (data: { u_id: string; }) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/benchmark/add_view_dashboard',
    method: 'post',
    data,
    errorHandler: true,
  }) as Promise<any>;
};

// 获取authpathtoken
export const getAuthToken: (data: {
  res_id: 'benchmark' ;
  game_code: string;
  menu_id: string;
  page_type: string;
  page_value: string;
}) => Promise<any> = (data) => {
  return http({
    url: '/api/v1/dashboard/auth_path_token',
    method: 'post',
    data,
    rawData: true,
  });
};
